import React from 'react';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import DataTable from "../../shared/component/dataTable/DataTable";
import PurchaseOrderColumn from "../../shared/component/dataTable/columns/PurchaseOrderColumn.json";
import PurchaseOrderMobileColumn from "../../shared/component/dataTable/columns/PurchaseOrderMobileColumn.json";
import {Button, Col, Row} from "reactstrap";
import Translate from "../../shared/language/Translate";
import {toast} from "react-toastify";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import LicenseService from "../../shared/service/LicenseService";
import PurchaseOrderService from "../../shared/service/PurchaseOrderService";
import AvField from "../../shared/component/form/AvField";
import {PURCHASE_ORDER_STATUS} from "../../shared/utils/Constants";
import {Calendar} from "primereact/calendar";
import {TabPanel, TabView} from 'primereact/tabview';
import dayjs from 'dayjs';
import '../../shared/styles/SettingsPage.css';

const LIST_FILTER_STORAGE_KEY = 'purchaseOrder.listFilter';
const OPEN_DETAIL_PAYMENTS_TAB_KEY = 'purchaseOrder.openDetailPaymentsTab';

function loadStoredListFilter() {
    try {
        const raw = sessionStorage.getItem(LIST_FILTER_STORAGE_KEY);
        if (!raw) {
            return {purchaseOrderStatus: 'INVOICE', activeTabIndex: 0};
        }
        const parsed = JSON.parse(raw);
        const statusValues = PURCHASE_ORDER_STATUS.map(item => item.value);
        const purchaseOrderStatus = statusValues.includes(parsed?.purchaseOrderStatus)
            ? parsed.purchaseOrderStatus
            : 'INVOICE';
        const activeTabIndex = parsed?.activeTabIndex === 1 ? 1 : 0;
        return {purchaseOrderStatus, activeTabIndex};
    } catch (e) {
        return {purchaseOrderStatus: 'INVOICE', activeTabIndex: 0};
    }
}

function saveStoredListFilter(purchaseOrderStatus, activeTabIndex) {
    try {
        sessionStorage.setItem(LIST_FILTER_STORAGE_KEY, JSON.stringify({
            purchaseOrderStatus,
            activeTabIndex: activeTabIndex === 1 ? 1 : 0
        }));
    } catch (e) {
        // ignore storage errors
    }
}

function setOpenDetailPaymentsTab(enabled) {
    try {
        if (enabled) {
            sessionStorage.setItem(OPEN_DETAIL_PAYMENTS_TAB_KEY, '1');
        } else {
            sessionStorage.removeItem(OPEN_DETAIL_PAYMENTS_TAB_KEY);
        }
    } catch (e) {
        // ignore
    }
}

export default class PurchaseOrder extends React.Component {
    constructor(props) {
        super(props);
        const stored = loadStoredListFilter();
        this.state = {
            hasInvoiceLicense: false,
            purchaseOrderStatus: stored.purchaseOrderStatus,
            id: "",
            activeTabIndex: stored.activeTabIndex,
            calendarMonth: new Date(),
            selectedCalendarDay: new Date(),
            paymentDues: [],
            paymentDuesLoading: false
        }
        this.licenseService = new LicenseService();
        this.purchaseOrderService = new PurchaseOrderService();
    }

    componentDidMount() {
        this.licenseService.getLicenses(localStorage.getItem("merchantBranchId")).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                if (response.hasInvoiceLicense == true && response.remainingCredit != null && response.remainingCredit > 0) {
                    this.setState({
                        hasInvoiceLicense: true
                    }, () => {
                        if (this.state.activeTabIndex === 1) {
                            this.loadPaymentDuesForMonth();
                        } else {
                            this.refreshDataTable();
                        }
                    });

                } else {
                    return toast.warn("You don't have an invoice license or your credit has run out.");
                }
            } else {
                return toast.warn("You don't have an invoice license or your credit has run out.");

            }
        });

        // 10 saniyede bir refresh (mevcut filtre/sorting korunur)
        this.refreshInterval = setInterval(() => {
            this.refreshDataTableSilent();
        }, 1000 * 10); // 10000ms = 10s
    }

    componentWillUnmount() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }



    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        {this.purchaseOrderList()}
                    </div>
                </AvForm>
            </div>
        );
    }

    purchaseOrderList() {
        return (
            <div className="settings-page__panel">
                <TabView
                    className="settings-page__tabs"
                    activeIndex={this.state.activeTabIndex || 0}
                    onTabChange={(e) => {
                        this.setState({activeTabIndex: e.index}, () => {
                            saveStoredListFilter(this.state.purchaseOrderStatus, e.index);
                            if (e.index === 0) {
                                this.refreshDataTable();
                            } else {
                                this.loadPaymentDuesForMonth();
                            }
                        });
                    }}
                >
                    <TabPanel header="Invoice List">
                        {this.renderInvoiceListTab()}
                    </TabPanel>
                    <TabPanel header="Payments">
                        {this.state.hasInvoiceLicense
                            ? this.renderPaymentCalendar()
                            : <div className="text-muted">Invoice license required.</div>}
                    </TabPanel>
                </TabView>
            </div>
        );
    }

    renderInvoiceListTab() {
        return (
            <>
                <div className="settings-page__invoice-toolbar settings-page__invoice-toolbar--in-tab settings-page__invoice-toolbar--stacked">
                    <div className="settings-page__invoice-toolbar-actions">
                        <div className="settings-page__toolbar settings-page__toolbar--start settings-page__toolbar--equal-height mb-0">
                            <Button color="outline-primary" className="settings-page__btn--add settings-page__btn--manual-entry"
                                    onClick={() => {
                                this.addNew("MANUAL_ENTRY");
                            }}>
                                <Translate contentKey="entity.action.add">Manual Entry</Translate>
                            </Button>

                            <Button color="outline-primary" className="settings-page__btn--add"
                                    style={{minWidth: '12.5rem'}}
                                    onClick={() => {
                                        this.addNew("UPLOAD");
                                    }}>
                                <Translate contentKey="entity.action.add">Smart Invoice Processor</Translate>
                            </Button>

                            <Button color="outline-primary" className="settings-page__btn--add"
                                              onClick={() => {
                                                  this.addNew("CSV");
                                              }}>
                                <Translate contentKey="entity.action.add">Import CSV</Translate>
                            </Button>
                        </div>
                        <div className="settings-page__invoice-toolbar-telegram">
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--action settings-page__btn--wrap"
                                onClick={() => {
                                    if (this.state.hasInvoiceLicense) {
                                        this.purchaseOrderService.telegramRegister().then((response) => {
                                            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                                window.open(response.url, '_blank');
                                            }
                                        });
                                    } else {
                                        return toast.warn("You don't have an invoice license or your credit has run out.");
                                    }
                                }}
                            >
                                <Translate contentKey="entity.action.add">Connect Telegram</Translate>
                            </Button>
                        </div>
                    </div>
                    <div className="settings-page__invoice-toolbar-status">
                        <AvGroup className="mb-0">
                            <AvField
                                type="select"
                                className="form-control"
                                name="purchaseOrderStatus"
                                disabled={false}
                                value={this.state.purchaseOrderStatus}
                                onChange={this.__handleChange}
                            >
                                {PURCHASE_ORDER_STATUS.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>
                                ))}
                            </AvField>
                        </AvGroup>
                    </div>
                </div>

                {this.state.hasInvoiceLicense &&
                    <div className="settings-page__table-wrap">
                        <DataTable
                            ref={(elem) => (this.refDataTable = elem)}
                            fields={(GeneralUtils.isMobile() ? PurchaseOrderMobileColumn.fields : PurchaseOrderColumn.fields)
                                .filter(field => {
                                    if (field.maxWidthVisible && window.innerWidth < field.maxWidthVisible) {
                                        return false;
                                    }
                                    // Payment summary only for CLOSED invoices
                                    if (field.paymentSummary && this.state.purchaseOrderStatus !== 'CLOSED') {
                                        return false;
                                    }
                                    return true;
                                })}
                            objectName={GeneralUtils.isMobile() ? PurchaseOrderMobileColumn.fields : PurchaseOrderColumn.fields}
                            dataURL={this.state.hasInvoiceLicense ? "inventory/purchaseOrder/all" : null}
                            rows={20}
                            autoLoad={false}
                            selectionMode="single"
                            onDataSelect={this.onDataSelect}
                            loading={this.state.loading}
                        />
                    </div>
                }
            </>
        );
    }

    renderPaymentCalendar() {
        const selectedDayKey = dayjs(this.state.selectedCalendarDay).format('YYYY-MM-DD');
        const duesForDay = (this.state.paymentDues || []).filter(item =>
            dayjs(item.paymentDueDate).format('YYYY-MM-DD') === selectedDayKey
        );
        const dueDaySet = new Set(
            (this.state.paymentDues || [])
                .map(item => dayjs(item.paymentDueDate).format('YYYY-MM-DD'))
                .filter(Boolean)
        );

        return (
            <div className="invoice-payment-calendar">
                <Row>
                    <Col md="5">
                        <Calendar
                            value={this.state.selectedCalendarDay}
                            inline
                            viewDate={this.state.calendarMonth}
                            onViewDateChange={(e) => {
                                this.setState({calendarMonth: e.value}, () => this.loadPaymentDuesForMonth());
                            }}
                            onChange={(e) => this.setState({selectedCalendarDay: e.value})}
                            dateTemplate={(dateMeta) => {
                                const key = dayjs(new Date(dateMeta.year, dateMeta.month, dateMeta.day)).format('YYYY-MM-DD');
                                const hasDue = dueDaySet.has(key);
                                return (
                                    <span style={{
                                        display: 'inline-block',
                                        minWidth: 28,
                                        borderRadius: 14,
                                        padding: '2px 4px',
                                        background: hasDue ? '#e8f1ff' : 'transparent',
                                        fontWeight: hasDue ? 700 : 400,
                                        color: hasDue ? '#1d4ed8' : undefined
                                    }}>
                                        {dateMeta.day}
                                    </span>
                                );
                            }}
                        />
                        <div className="text-muted" style={{marginTop: 8, fontSize: 12}}>
                            Highlighted days have unpaid/partial invoices due.
                        </div>
                    </Col>
                    <Col md="7">
                        <h5 style={{marginBottom: 12}}>
                            Due on {dayjs(this.state.selectedCalendarDay).format('DD/MM/YYYY')}
                        </h5>
                        {this.state.paymentDuesLoading && <div>Loading…</div>}
                        {!this.state.paymentDuesLoading && duesForDay.length === 0 &&
                            <div className="text-muted">No upcoming payments on this day.</div>}
                        {!this.state.paymentDuesLoading && duesForDay.map(item => (
                            <div
                                key={item.id}
                                onClick={() => this.onDataSelect(item)}
                                style={{
                                    border: '1px solid #e5e7eb',
                                    borderRadius: 8,
                                    padding: '10px 12px',
                                    marginBottom: 8,
                                    cursor: 'pointer'
                                }}
                            >
                                <div style={{fontWeight: 600}}>
                                    {item.invoiceNumber || ('Invoice #' + item.id)} — {item.supplierName || '-'}
                                </div>
                                <div style={{fontSize: 13, color: '#4b5563'}}>
                                    Remaining £{Number(item.remainingAmount || 0).toFixed(2)}
                                    {' · '}
                                    {item.paymentStatus || 'UNPAID'}
                                </div>
                            </div>
                        ))}
                    </Col>
                </Row>
            </div>
        );
    }

    loadPaymentDuesForMonth = () => {
        if (!this.state.hasInvoiceLicense) {
            return;
        }
        const month = dayjs(this.state.calendarMonth || new Date());
        const from = month.startOf('month').format('YYYY-MM-DD');
        const to = month.endOf('month').format('YYYY-MM-DD');
        this.setState({paymentDuesLoading: true});
        this.purchaseOrderService.findPaymentDues(from, to).then(response => {
            this.setState({
                paymentDuesLoading: false,
                paymentDues: Array.isArray(response) ? response : []
            });
        }).catch(() => this.setState({paymentDuesLoading: false, paymentDues: []}));
    };


    refreshDataTable = () => {
        if (!this.state.hasInvoiceLicense || !this.refDataTable) return;

        const { purchaseOrderStatus } = this.state;
        let value = purchaseOrderStatus;
        let type = "string";
        let filterMatchMode = "equals";

        if (purchaseOrderStatus === "INVOICE") {
            value = ["INVOICE", "PARTIAL_CLOSED"];
            type = "list";
            filterMatchMode = "in";
        }

        if (this.refDataTable.dt) {
            this.refDataTable.dt.filter(value, "purchaseOrderStatus", filterMatchMode);
        }

        this.refDataTable.onModelFilterChangeWithNameAndValue(
            "purchaseOrderStatus",
            value,
            type,
            null,
            filterMatchMode
        );
    };

    refreshDataTableSilent = () => {
        if (this.state.activeTabIndex === 1) {
            return;
        }
        if (!this.state.hasInvoiceLicense || !this.refDataTable) return;

        const { purchaseOrderStatus } = this.state;
        let value = purchaseOrderStatus;
        let type = "string";
        let filterMatchMode = "equals";

        if (purchaseOrderStatus === "INVOICE") {
            value = ["INVOICE", "PARTIAL_CLOSED"];
            type = "list";
            filterMatchMode = "in";
        }

        this.refDataTable.reloadWithCurrentState({
            purchaseOrderStatus: { value, type, filterMatchMode }
        });
    };


    onDataSelect = (data) => {
        if (this.state.hasInvoiceLicense) {
            saveStoredListFilter(this.state.purchaseOrderStatus, this.state.activeTabIndex);
            setOpenDetailPaymentsTab(this.state.activeTabIndex === 1);
            window.location.href = "#purchaseOrderSave?" + data.id + "?" + (data.invoiceType || '');
        } else {
            return toast.warn("You don't have an invoice license or your credit has run out.");

        }

    }

    addNew(invoiceType) {
        if (this.state.hasInvoiceLicense) {
            saveStoredListFilter(this.state.purchaseOrderStatus, this.state.activeTabIndex);
            setOpenDetailPaymentsTab(false);
            window.location.href = "#purchaseOrderSave?" + "-1" + "?" + invoiceType;
        } else {
            return toast.warn("You don't have an invoice license or your credit has run out.");

        }


    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;

        this.setState({
            purchaseOrderStatus: value
        }, () => {
            saveStoredListFilter(value, this.state.activeTabIndex);
            this.refreshDataTable()
        });
    }


}
